export default {
  hero: {
    badge: 'AllChinaBuy Spreadsheet Resource Hub',
    title: 'AllChinaBuy Spreadsheet – Find Products, Compare Options & Buy Smarter',
    subtitle: 'Explore the AllChinaBuy Spreadsheet in one organized place. Discover product finds, popular categories, QC guides, shipping information, reviews and practical buying resources.',
    ctaPrimary: 'Explore AllChinaBuy Spreadsheet',
    ctaSecondary: 'Browse Popular Finds',
    mainCta1: 'allchinabuy spreadsheet',
    mainCta2: 'buy it now',
  },
  search: {
    label: 'Search the AllChinaBuy Spreadsheet',
    placeholder: 'Search categories, guides, reviews...',
    categoryLabel: 'Browse by category',
    selectPlaceholder: 'Select a category',
    go: 'Go to category',
  },
  categories: {
    title: 'Popular Categories',
    subtitle: 'Jump straight into the products you care about. Every category opens on the main AllChinaBuy spreadsheet.',
  },
  guides: {
    title: 'Guides & Resources',
    subtitle: 'Practical walkthroughs covering quality checks, shipping, reviews and safe buying.',
  },
  featured: {
    title: 'Featured Finds',
    subtitle: 'A rotating look at the kinds of products people save most often in their spreadsheets.',
    items: [
      { title: 'Everyday Sneakers That Hold Up', body: 'Clean silhouettes and solid materials make these a repeat save across dozens of buyer lists.' },
      { title: 'Boxy Streetwear Hoodies', body: 'Heavyweight cotton and oversized fits dominate the hoodie section of the spreadsheet.' },
      { title: 'Minimal Logo Tees', body: 'Simple, versatile tees that layer well and stay in budget for most first-time buyers.' },
      { title: 'Utility Jackets & Outerwear', body: 'Technical fabrics and relaxed cuts that work across seasons.' },
    ],
  },
  qc: {
    title: 'QC Guide',
    subtitle: 'How to read quality-check photos before you ship.',
    body: 'Before your items leave the warehouse, review the QC photos carefully. Check stitching, color accuracy, logo placement and measurements against the size chart.',
  },
  shipping: {
    title: 'Shipping Guide',
    subtitle: 'Understand your shipping options and costs.',
    body: 'Compare shipping lines by speed, price and reliability. Heavier or bulkier items usually cost more, so consolidating a full haul often saves money.',
  },
  review: {
    title: 'AllChinaBuy Review',
    subtitle: 'An honest look at how it works.',
    body: 'From placing an order to tracking a parcel, learn what to expect, where the service shines and what to watch out for.',
  },
  safety: {
    title: 'Safety Center',
    subtitle: 'Buy with confidence.',
    body: 'Tips for account security, safe payment, avoiding counterfeit risks and understanding customs and restricted products.',
  },
  articles: {
    title: 'Latest Articles',
    subtitle: 'In-depth guides and honest write-ups to help you buy smarter.',
    readMore: 'Read article',
    viewAll: 'View all articles',
  },
  faq: {
    title: 'Frequently Asked Questions',
    subtitle: 'Quick answers to the most common questions.',
    items: [
      { q: 'What is the AllChinaBuy Spreadsheet?', a: 'It is an organized collection of product finds, categories and buying resources that helps you discover and compare items before purchasing.' },
      { q: 'Is AllChinaBuy legitimate?', a: 'Always verify current policies yourself. Our guides help you understand the process, but you should review terms, seller ratings and local regulations before ordering.' },
      { q: 'How much does shipping cost?', a: 'Shipping cost depends on weight, size, destination and the shipping line you choose. Consolidating items into one parcel often reduces the total.' },
      { q: 'How do I read QC photos?', a: 'Check stitching, colors, logos and measurements against the listing and size chart. Report any mismatch before your items ship.' },
    ],
  },
  cta: {
    title: 'Ready to explore the full spreadsheet?',
    subtitle: 'Visit the main website to browse every category and find your next favorite item.',
    button: 'Visit Main Website',
  },
};